// extracted by mini-css-extract-plugin
export var hidden = "_4q-1";
export var leftPanel = "_4q-2";
export var readonlyInspector = "_4q-3";
export var rightPanel = "_4q-0";